import React from 'react';
import { SVGAttributes } from 'react';

export const ClipboardGreyIcon: React.FC<SVGAttributes<never>> = (props) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="clipboard 1">
        <path
          id="Vector"
          d="M7.40689 49.1068C7.40689 36.8099 1.03711 28.3654 1.03711 22.4401C1.03711 16.5148 4.44333 4.07031 31.702 4.07031C58.9607 4.07031 62.9607 20.8116 62.9607 27.329C62.9624 57.8481 7.40689 70.8845 7.40689 49.1068Z"
          fill="#EFEFEF"
        />
        <path
          id="Vector_2"
          d="M6.22331 10.6654C4.75309 10.6654 3.55664 9.46892 3.55664 7.9987C3.55664 6.52848 4.75309 5.33203 6.22331 5.33203C7.69353 5.33203 8.88997 6.52848 8.88997 7.9987C8.88997 9.46892 7.69353 10.6654 6.22331 10.6654ZM6.22331 7.10981C5.73442 7.10981 5.33442 7.50803 5.33442 7.9987C5.33442 8.48936 5.73442 8.88759 6.22331 8.88759C6.7122 8.88759 7.1122 8.48936 7.1122 7.9987C7.1122 7.50803 6.7122 7.10981 6.22331 7.10981Z"
          fill="#F7F7F9"
        />
        <path
          id="Vector_3"
          d="M20.8895 17.332C18.9251 17.332 17.334 18.9231 17.334 20.8876V48.4431C17.334 50.4076 18.9251 51.9987 20.8895 51.9987H43.1118C45.0762 51.9987 46.6673 50.4076 46.6673 48.4431V20.8876C46.6673 18.9231 45.0762 17.332 43.1118 17.332H20.8895Z"
          fill="#F3F3F1"
        />
        <path
          id="Vector_4"
          d="M39.5545 15.5556V19.1111C39.5545 20.0924 38.758 20.8889 37.7767 20.8889H26.2211C25.2398 20.8889 24.4434 20.0924 24.4434 19.1111V15.5556H28.4434C28.4434 13.6 30.0434 12 31.9989 12C33.9545 12 35.5545 13.6 35.5545 15.5556H39.5545Z"
          fill="#F7F7F9"
        />
        <path
          id="Vector_5"
          d="M21.334 48.4431V20.8876C21.334 18.9231 22.9251 17.332 24.8895 17.332H20.8895C18.9251 17.332 17.334 18.9231 17.334 20.8876V48.4431C17.334 50.4076 18.9251 51.9987 20.8895 51.9987H24.8895C22.9251 51.9987 21.334 50.4076 21.334 48.4431Z"
          fill="#D5DBE1"
        />
        <g id="Group">
          <path
            id="Vector_6"
            d="M33.997 12.6222C33.4263 12.2311 32.7383 12 31.997 12C30.0414 12 28.4414 13.6 28.4414 15.5556H32.4414C32.4414 14.3413 33.0601 13.264 33.997 12.6222Z"
            fill="white"
          />
          <path
            id="Vector_7"
            d="M28.4414 19.1122V15.5566H24.4414V19.1122C24.4414 20.0935 25.2379 20.89 26.2192 20.89H30.2192C29.2379 20.89 28.4414 20.0935 28.4414 19.1122Z"
            fill="white"
          />
        </g>
        <path
          id="Vector_8"
          d="M43.1111 53.3333H20.8889C18.192 53.3333 16 51.1413 16 48.4444V20.8889C16 18.192 18.192 16 20.8889 16H24.2364V18.6667H20.8889C19.664 18.6667 18.6667 19.664 18.6667 20.8889V48.4444C18.6667 49.6693 19.664 50.6667 20.8889 50.6667H43.1111C44.336 50.6667 45.3333 49.6693 45.3333 48.4444V20.8889C45.3333 19.664 44.336 18.6667 43.1111 18.6667H39.7636V16H43.1111C45.808 16 48 18.192 48 20.8889V48.4444C48 51.1413 45.808 53.3333 43.1111 53.3333Z"
          fill="#ABABAB"
        />
        <path
          id="Vector_9"
          d="M37.7799 22.2235H26.2244C24.5088 22.2235 23.1133 20.828 23.1133 19.1124V15.5569C23.1133 14.8209 23.7106 14.2235 24.4466 14.2235H27.2982C27.8813 12.1737 29.7693 10.668 32.0022 10.668C34.2351 10.668 36.1231 12.1737 36.7062 14.2235H39.5577C40.2937 14.2235 40.8911 14.8209 40.8911 15.5569V19.1124C40.8911 20.828 39.4955 22.2235 37.7799 22.2235ZM25.7799 16.8902V19.1124C25.7799 19.3577 25.9791 19.5569 26.2244 19.5569H37.7799C38.0253 19.5569 38.2244 19.3577 38.2244 19.1124V16.8902H35.5577C34.8217 16.8902 34.2244 16.2929 34.2244 15.5569C34.2244 14.332 33.2271 13.3346 32.0022 13.3346C30.7773 13.3346 29.7799 14.332 29.7799 15.5569C29.7799 16.2929 29.1826 16.8902 28.4466 16.8902H25.7799Z"
          fill="#ABABAB"
        />
        <path
          id="Vector_10"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.7611 30.4487C28.7611 27.611 31.0164 25.3105 33.7985 25.3105C34.2118 25.3105 34.6135 25.3613 34.9979 25.4571C32.7948 26.0059 31.1599 28.0326 31.1599 30.4487C31.1599 32.8647 32.7948 34.8914 34.9979 35.4402C34.6135 35.536 34.2118 35.5868 33.7985 35.5868C31.0164 35.5868 28.7611 33.2864 28.7611 30.4487ZM24.4434 40.5566C24.4434 39.9566 24.7681 39.4056 25.2875 39.124C28.3122 37.4845 31.6784 36.7769 34.9978 37.0011C32.477 37.1713 29.9832 37.879 27.6863 39.124C27.1668 39.4056 26.8421 39.9566 26.8421 40.5566V44.1502C26.8421 45.0961 27.5939 45.8629 28.5212 45.8629H26.1225C25.1951 45.8629 24.4434 45.0961 24.4434 44.1502L24.4434 40.5566Z"
          fill="#D6DBE1"
        />
        <path
          id="Vector_11"
          d="M28.6641 30.4487C28.6641 28.5594 30.1643 27.0366 32.0042 27.0366C33.844 27.0366 35.3442 28.5594 35.3442 30.4487C35.3442 32.3379 33.844 33.8607 32.0042 33.8607C30.1643 33.8607 28.6641 32.3379 28.6641 30.4487ZM32.0042 25.0525C29.0748 25.0525 26.7087 27.4733 26.7087 30.4487C26.7087 33.424 29.0748 35.8448 32.0042 35.8448C34.9335 35.8448 37.2996 33.424 37.2996 30.4487C37.2996 27.4733 34.9335 25.0525 32.0042 25.0525Z"
          fill="#ABABAB"
          stroke="#ABABAB"
          strokeWidth="0.516129"
        />
        <path
          id="Vector_12"
          d="M23.3657 38.8955L23.3657 38.8955C22.7614 39.223 22.3865 39.8621 22.3865 40.5549V44.1486C22.3865 45.2322 23.249 46.1194 24.3237 46.1194H39.6756C40.7503 46.1194 41.6128 45.2322 41.6128 44.1486V40.5549C41.6128 39.8621 41.2378 39.223 40.6335 38.8955C35.2353 35.9694 28.764 35.9694 23.3657 38.8955ZM24.3419 44.1352V40.616C29.1351 38.0415 34.8642 38.0415 39.6574 40.6161V44.1352H24.3419Z"
          fill="#ABABAB"
          stroke="#ABABAB"
          strokeWidth="0.516129"
        />
      </g>
    </svg>
  );
};

export default ClipboardGreyIcon;
